import styled from "styled-components";

export const StyledLegendDot = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const StyledDot = styled.span<{ $color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  display: inline-block;
  flex-shrink: 0;
`;
